const apiUrl = import.meta.env.VITE_FIREBASE_TRUCKYARD_API_URL;

export interface FetchAccessesParams {
  yardId: string;
  itemsPerPage?: number;
  lastDocId?: string;
}

export const fetchAccesses = async ({
  yardId,
  itemsPerPage,
  lastDocId,
}: FetchAccessesParams): Promise<any> => {
  const userId = import.meta.env.VITE_OASIS_USER_ID;
  let url = `${apiUrl}/access?yardId=${yardId}&userId=${userId}`;
  if (itemsPerPage) url += `&itemsPerPage=${itemsPerPage}`;
  if (lastDocId) url += `&lastDocId=${lastDocId}`;

  const res = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      // ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  if (!res.ok) {
    throw new Error(
      `Error al obtener accesos: ${res.status} ${res.statusText}`
    );
  }
  const data = await res.json();
  // Si viene paginado, retorna el objeto completo (page, totalPages, lastDocId)
  if (data.page && data.totalPages !== undefined) {
    return {
      page: data.page,
      totalPages: data.totalPages,
      lastDocId: data.lastDocId,
    };
  }
  // Si no, retorna solo la lista
  return data.data ?? data.page;
};

export interface FetchAccessHistoryParams {
  yardId: string;
  accessId: string;
  itemsPerPage?: number;
  lastDocId?: string;
}

export const fetchAccessHistory = async ({
  yardId,
  accessId,
  itemsPerPage,
  lastDocId,
}: FetchAccessHistoryParams): Promise<any> => {
  const userId = import.meta.env.VITE_OASIS_USER_ID;
  
  let url = `${apiUrl}/access/accessHistory?yardId=${yardId}&accessId=${accessId}&userId=${userId}`;
  if (itemsPerPage) url += `&itemsPerPage=${itemsPerPage}`;
  if (lastDocId) url += `&lastDocId=${lastDocId}`;

  const res = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  
  if (!res.ok) {
    throw new Error(
      `Error al obtener historial de accesos: ${res.status} ${res.statusText}`
    );
  }
  const data = await res.json();
  if (data.page && data.totalPages !== undefined) {
    return {
      page: data.page,
      totalPages: data.totalPages,
      lastDocId: data.lastDocId,
    };
  }
  return data.data ?? data.page;
};
